import { render, staticRenderFns } from "./PageItem.vue?vue&type=template&id=1960fa80&scoped=true&"
import script from "./PageItem.vue?vue&type=script&lang=js&"
export * from "./PageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1960fa80",
  null
  
)

export default component.exports